import {
  DEFAULT_WORLD_BALANCE,
  type WorldBalance,
} from "../../models/config/worldBalance.ts";
import type { ClanState } from "../../models/worldState.ts";

export type TurnOutcome = "continue" | "victory" | "defeat";

export interface EndTurnClanResult {
  clan: ClanState;
  outcome: TurnOutcome;
  netGain: number;
}

export function resolveEndTurnClan(
  clan: ClanState,
  foodProduction: number,
  balance: WorldBalance = DEFAULT_WORLD_BALANCE,
): EndTurnClanResult {
  const production = foodProduction;
  const netGain = production - clan.population;
  let foodSupplies = clan.foodSupplies + netGain;

  let foodBankStreak =
    foodSupplies >= balance.foodBankGrowthThreshold ? clan.foodBankStreak + 1 : 0;
  let famineStreak =
    netGain <= 0 && foodSupplies < balance.foodBankGrowthThreshold
      ? clan.famineStreak + 1
      : 0;
  let population = clan.population;

  if (foodBankStreak >= balance.growthStreakRequired) {
    population += 1;
    foodBankStreak = 0;
    foodSupplies -= balance.foodBankGrowthCost;
  } else if (famineStreak >= balance.famineStreakRequired) {
    population -= 1;
    famineStreak = 0;
  }

  const nextClan: ClanState = {
    ...clan,
    foodSupplies,
    foodBankStreak,
    famineStreak,
    population,
  };

  if (nextClan.population >= balance.victoryPopulation) {
    return { clan: nextClan, outcome: "victory", netGain };
  }

  if (nextClan.population <= balance.defeatPopulation) {
    return { clan: nextClan, outcome: "defeat", netGain };
  }

  return { clan: nextClan, outcome: "continue", netGain };
}
